import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { CLOSE_OUT_PATH, CLOSE_OUT_TABS } from './distance-agreement.paths';
import { CloseOutPage } from './pages/CloseOutPage';
import { TripDistancePage } from './pages/TripDistancePage';

export const DISTANCE_AGREEMENT_ROUTES: RouteObject[] = [
  ...recordTabRoutes(CLOSE_OUT_PATH.slice(1), CLOSE_OUT_TABS, (tab) => <CloseOutPage tab={tab} />),
  { path: `${CLOSE_OUT_PATH.slice(1)}/trips/:tripId`, element: <TripDistancePage /> },
];
